import states, { stateMap, canadaStates } from './states'

const mappingVariables = ({ breedsData }) => ({
  breed: {
    key: (value) => isNaN(value) ? 'breedSlug' : 'breedId',
    convert: (value) => isNaN(value) ? value : +value,
    isValid: (value) => breedsData?.some(breed => isNaN(value) ? breed.slug === value : breed.id === value)
  },
  category: {
    key: () => 'category',
    convert: (value) => value,
    isValid: (value) => {
      const categories = ['kid_friendly', 'small', 'hypoallergenic', 'emotional_support', 'guard', 'hunting', 'active', 'doodle', 'service', 'apartment', 'therapy', 'trained']
      return categories.includes(value)
    }
  },
  zipcode: {
    key: () => 'zipcode',
    convert: (value) => value,
    isValid: async (value) => {
      const zipcodes = (await import('zipcodes')).default
      return !!zipcodes.lookup(value)
    }
  },
  price: {
    key: () => 'price',
    convert: (value) => +value,
    isValid: (value) => typeof value === 'number' && value <= 11
  },
  size: {
    key: () => 'size',
    convert: (value) => value,
    isValid: (value) => {
      const sizes = ['XS', 'S', 'M', 'L']
      return sizes.includes(value)
    }
  },
  gender: {
    key: () => 'gender',
    convert: (value) => value,
    isValid: (value) => value === 'Male' || value === 'Female'
  },
  hypoallergenic: {
    key: () => 'hypoallergenic',
    convert: (value) => value === 'true',
    isValid: (value) => value === true
  },
  color: {
    key: () => 'color',
    convert: (value) => value,
    isValid: (value) => {
      const colors = ['black', 'brown', 'blue', 'cream', 'gold', 'grey', 'red']
      return colors.includes(value)
    }
  },
  state: {
    key: () => 'state',
    convert: (value) => {
      Object.keys(stateMap).map(key => {
        if (value === key) value = stateMap[key]?.state
        return value
      })
      return value
    },
    isValid: (value) => states.includes(value) || canadaStates.includes(value)
  },
  sort: {
    key: () => 'sort',
    convert: (value) => value,
    isValid: (value) => {
      const options = ['by-featured', 'most-viewed', 'price-low-to-high', 'price-high-to-low', 'closest']
      return options.includes(value)
    }
  },
  page: {
    key: () => 'page',
    convert: (value) => value,
    isValid: (value) => !isNaN(value)
  }
})

export {
  mappingVariables
}
